import { IApplicationState } from '../../types/redux';

export const selectSeoUrls = (state: IApplicationState) => state.seoUrls;
